import { createMemo, Show } from "solid-js"
import debounce from "../../lib/ldsh/debounce"
import { getColor, setColor } from "../../rx/signal/useSharedColorSignal"

interface ColorPickerProps {
  label?: string
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
  showHex?: boolean
}

export default function ColorPicker(props: ColorPickerProps) {
  // Use default color from props if provided, otherwise use the shared signal
  // @ts-expect-error debounce is pass-thru
  const setCurrentColor = debounce((color: string) => {
    // If defaultColor is provided, we don't update the shared signal
    // if (!props.defaultColor) {
      setColor(color)
    // }
  }, 100)

  const position = () => props.position || 'bottom-right'
  const showHex = () => props.showHex ?? true

  const positionStyles = createMemo(() => {
    const pos = position()
    switch (pos) {
      case 'top-left':
        return { 'top': '20px', 'left': '20px', 'right': 'auto', 'bottom': 'auto' }
      case 'top-right':
        return { 'top': '20px', 'right': '20px', 'left': 'auto', 'bottom': 'auto' }
      case 'bottom-left':
        return { 'bottom': '20px', 'left': '20px', 'right': 'auto', 'top': 'auto' }
      case 'bottom-right':
      default:
        return { 'bottom': '20px', 'right': '20px', 'left': 'auto', 'top': 'auto' }
    }
  })

  return (
    <div style={{
      'position': 'fixed',
      ...positionStyles(),
      'background': 'rgba(0,0,0,0.7)',
      'padding': '10px',
      'border-radius': '8px',
      'z-index': 1000,
      'display': 'flex',
      'flex-direction': 'column',
      'gap': '8px',
      'color': 'white',
      'font-family': 'sans-serif',
      'font-size': '14px'
    }}>
      <Show when={props.label}>
        <div style={{ 'font-weight': 'bold' }}>{props.label}</div>
      </Show>
      
      <div style={{ 'display': 'flex', 'gap': '8px', 'align-items': 'center' }}>
        <input
          type="color"
          value={getColor()}
          onInput={(e) => setCurrentColor(e.currentTarget.value)}
          style={{ 'width': '50px', 'height': '24px', 'padding': '0', 'border': 'none' }}
        />
        <Show when={showHex()}>
          <div style={{ 
            'font-family': 'monospace',
            'min-width': '70px',
            'text-align': 'center',
            'background': 'rgba(255,255,255,0.1)',
            'padding': '2px 6px',
            'border-radius': '4px'
          }}>
            {getColor().toUpperCase()}
          </div>
        </Show>
      </div>
    </div>
  )
}
